import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CmsService {
  hasSearchResults = new BehaviorSubject(false);

  constructor() { }

  setHasSearchResults(state: boolean): any {
    this.hasSearchResults.next(state);
  }

  getHasSearchResults() {
    return this.hasSearchResults.asObservable()
  }
}
